import { StyleSheet, View, Text } from "react-native";
import utf8 from "utf8";
import SimplePress from "./SimplePress";
import { timeValue, getSchemeStyle } from "../context/helper";
import RSSIImage from "./RSSIImage";
//import Feather from "react-native-vector-icons/Feather";
import { Feather } from "./VectorIcons";
import CustomSwitch from "./CustomSwitch";
import { useState, useEffect } from "react";
//import ActivityScreen from "../screens/activityscreen";

export const SensorMainSubitem = (props, key) => {
  const schemeStyles = getSchemeStyle();

  let sensor = props.item;
  return sensor ? (
    <SimplePress onPress={props.onPress}>
      <View key={key} style={[styles.itemContainer,schemeStyles.Border]}>
        <View style={styles.mainSection}>
          <Text
            style={[styles.nameText, schemeStyles.defaultText, sensor.sensorError && schemeStyles.errorText]}
          >
            {sensor.sensorName}
          </Text>
          <Text
            style={[
              styles.nameText,schemeStyles.defaultText,
              sensor.sensorErrorData.interval && schemeStyles.errorText,
            ]}
          >
            {sensor.sensorTemp === null ? "neu" : timeValue(sensor.sensorTime)}
          </Text>
        </View>
        <View style={styles.tempSection}>
          {sensor.sensorTemp === null || sensor.sensorTemp === -99 ? (
            <View style={styles.noValue}>
              <Feather name="minus" size={18} color={schemeStyles.defaultText.color} />
              <Feather name="minus" size={18} color={schemeStyles.defaultText.color} />
              <Feather name="minus" size={18} color={schemeStyles.defaultText.color} />
            </View>
          ) : (
            <Text
              style={[
                styles.infoText,
                styles.tempText,schemeStyles.defaultText,
                sensor.sensorErrorData.temperature && schemeStyles.errorText,
              ]}
            >
              {sensor.sensorTemp + "°C"}
            </Text>
          )}
        </View>
        <View style={styles.infoSection}>
          <Text style={[styles.infoText,schemeStyles.defaultText]}>
            {sensor.sensorVersion && `v${sensor.sensorVersion}`}
          </Text>
          <Text
            style={[
              styles.infoText,schemeStyles.defaultText,
              sensor.sensorErrorData.voltage && schemeStyles.errorText,
            ]}
          >
            {sensor.sensorVolt}V
          </Text>
          <View style={styles.rssiContainer}>
            <RSSIImage
              style={{ marginRight: 5 }}
              size={16}
              rssi={sensor.sensordBm}
              goodColor={schemeStyles.rssiImage.goodColor}
              weakColor={schemeStyles.rssiImage.weakColor}
              badColor={schemeStyles.rssiImage.badColor}
              doincrease={schemeStyles.rssiImage.doincrease}
            />
            <Text style={[styles.infoText,schemeStyles.defaultText]}>{sensor.sensordBm}dBm</Text>
          </View>
        </View>
      </View>
    </SimplePress>
  ) : (
    <View key={key} style={[styles.emptyContainer,schemeStyles.Border]}></View>
  );
};
/* 01 - Büro (Aktiv)
ID: 2
Fehler immer senden: Nein
Auto-Update: Ja
Offline-Sensor: Nein
 
'offlinesensor' => $sensor->offlinesensor,
'errsendalways' => $sensor->errorsendalways,
'isactive' => $sensor->isactive,


'minvalue' => $sensor->minvalue1,
'maxvalue' => $sensor->maxvalue1,

'board' => [
    'id' => $sensor->boardid
],
'device' => [
    'id' => $sensor->sensor->id,
    'name' => $sensor->sensor->name,
    'unit' => $sensor->sensor->unit1,
    'typ' => $sensor->sensor->typ
]
*/
export const MeasuringPointMainSubitem = (props, key) => {
  const schemeStyles = getSchemeStyle();

  const [dataLoaded, setDataLoaded] = useState(false);
  const [sensor, setSensor] = useState(undefined);
  const [active, setActive] = useState(sensor ? sensor.isactive : false);

  useEffect(() => {
    setDataLoaded(false);
    setSensor(props.item);
    setActive(props.item ? props.item.isactive : false);
    setDataLoaded(true);
  }, [props]);

  const useThresholds = () => {
    return sensor.minvalue !== false || sensor.maxvalue !== false;
  };

  const thresholdString = () => {
    return sensor.minvalue === false
      ? `< ${sensor.maxvalue}°C`
      : sensor.maxvalue === false
      ? `> ${sensor.minvalue}°C`
      : `${sensor.minvalue}°C bis ${sensor.maxvalue}°C`;
  };

  if (!dataLoaded) {
    return;
    /*
   
    (
         <ActivityScreen/>
    );
 */
  }

  return sensor ? (
    <View>
      <SimplePress onPress={props.onPress}>
        <View
          key={key}
          style={[styles.itemContainer, { flexDirection: "column" }, schemeStyles.Border]}
        >
          <View style={styles.mainSection}>
            <Text style={[styles.nameText, { fontSize: 18 },schemeStyles.defaultText]}>
              {sensor.name}
            </Text>
          </View>
          <View style={styles.subSection}>
            {useThresholds() && <Text style={schemeStyles.defaultText}>{`Bereich: ${thresholdString()}`}</Text>}
            {sensor.board.id && <Text style={schemeStyles.defaultText}>{`Board-ID: #${sensor.board.id}`}</Text>}
            <Text style={schemeStyles.defaultText}>{`Fehler immer senden: ${
              sensor.errsendalways ? "Ja" : "Nein"
            }`}</Text>
            <Text style={schemeStyles.defaultText}>{`Offline-Sensor: ${
              sensor.offlinesensor ? "Ja" : "Nein"
            }`}</Text>
          </View>
        </View>
        <View style={styles.idContainer}>
          <Text
            style={[
              styles.idText,
              active ? { color: schemeStyles.idText.activeColor } : { color: schemeStyles.idText.inactiveColor },
            ]}
          >{`#${sensor.id}`}</Text>
        </View>
      </SimplePress>
      <View style={styles.switchContainer}>
        <CustomSwitch
          onColor={schemeStyles.switchColors.blueOnColor}
          offColor={schemeStyles.switchColors.offColor}
          disabledColor={schemeStyles.switchColors.disabledColor}
          circleActiveColor={schemeStyles.switchColors.circleActiveColor}
          circleInActiveColor={schemeStyles.switchColors.circleInActiveColor}
          value={active}
          onValueChange={(val) => {
            setActive(val);

            if (props.onActivate) {
              props.onActivate(sensor.id, val);
            }
          }}
        />
      </View>
    </View>
  ) : (
    <View key={key} style={[styles.emptyContainer,schemeStyles.Border]}></View>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: "row",
    marginBottom: 5,
    padding: 3,
    borderTopWidth: 1,
  },
  emptyContainer: {
    marginBottom: 15,
    borderBottomWidth: 2,
  },

  mainSection: {
    flex: 11,
    marginLeft: 5,
  },
  subSection: {
    marginLeft: 15,
  },
  tempSection: {
    flex: 3,
    marginRight: 10,
    alignItems: "center",
    flexDirection: "row",
  },
  infoSection: { flex: 3 },
  nameText: {
    flex: 1,
    fontFamily: "Roboto-Regular",
  },
  infoText: {
    fontFamily: "Roboto-Regular",
    textAlign: "right",
    fontSize: 12,
  },
  tempText: {
    fontFamily: "Roboto-Bold",
    fontSize: 20,
    flex: 1,
  },
  rssiContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  noValue: {
    flexDirection: "row",
    flex: 1,
    justifyContent: "flex-end",
  },
  switchContainer: {
    position: "absolute",
    right: 10,
    top: 10,
    alignItems: "flex-end",
  },
  idContainer: {
    position: "absolute",
    right: 10,
    top: 40,
    alignItems: "flex-end",
  },
  idText: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
  },
});
